import { render, staticRenderFns } from "./BasketSettings.vue?vue&type=template&id=3f44c199&scoped=true&"
import script from "./BasketSettings.vue?vue&type=script&lang=ts&"
export * from "./BasketSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f44c199",
  null
  
)

export default component.exports